module.exports = __webpack_public_path__ + "img/轮播图3.22aa9cf8.png";